import type { Theme } from '@mui/material';
import { Button, Container, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import Drawing from '/@/components/drawing';
import { _ } from '/@/locale';
import { linkFieldviewAccount } from '/@/store/session/actions';
import { reverse } from '/@/utils/router';

const ImportField = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(
            linkFieldviewAccount({
                source: 'new-field',
                onSuccess: () => {
                    navigate(reverse('NewHome', { qs: { provider: 'fieldview' } }));
                },
            })
        );
    }, [dispatch, navigate]);

    return (
        <Container
            maxWidth='sm'
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}
        >
            <Stack
                sx={{
                    background: 'white',
                    border: (t: Theme) => `1px solid ${t.palette.divider}`,
                    borderRadius: '4px',
                }}
            >
                <Stack justifyContent={'center'} alignItems={'center'} textAlign={'center'} p={4} spacing={2}>
                    <Drawing type='success-corn' />
                    <Typography fontWeight={500} fontSize={'20px'}>
                        {_('Sincronizar con Fieldview')}
                    </Typography>
                    <Typography>
                        {_(
                            'Para sincronizar tus lotes con Fieldview debes iniciar sesion. Este proceso puede tardar unos minutos.'
                        )}
                    </Typography>
                </Stack>
                <Stack
                    direction={'row'}
                    justifyContent={'space-between'}
                    sx={{
                        borderTop: (t: Theme) => `1px solid ${t.palette.divider}`,
                    }}
                    alignItems={'center'}
                    textAlign={'initial'}
                    p={2}
                >
                    <Button
                        color='secondary'
                        variant='text'
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        {_('Cancelar')}
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => {
                            dispatch(
                                linkFieldviewAccount({
                                    source: 'new-field',
                                    onSuccess: () => {
                                        navigate(reverse('NewHome', { qs: { provider: 'fieldview' } }));
                                    },
                                })
                            );
                        }}
                    >
                        {_('Re-abrir ventana')}
                    </Button>
                </Stack>
            </Stack>
        </Container>
    );
};

export default ImportField;
